"use strict";
/**
 * trsHight Module
 *
 * Description
 */
angular.module('trsPositionFixedModule', []).directive('trsPositionFixed', ['$window', '$parse', '$timeout', function ($window, $parse, $timeout) {

    return {
        restrict: 'EA',
        link: function (scope, iElement, iAttrs) {
            positionFixed();

            function positionFixed() {
                var $contentTextWrap = $(".content_text_wrap");
                
                $contentTextWrap.scroll(function () {
                    $timeout.cancel(scope.timer);
                    scope.timer = $timeout(function () {
                        var fixedItem = iElement.find(".panel-heading");
                        var fixedCollapse = iElement.find(".panel-collapse");
                        fixedCollapse.each(function (index, el) {
                            if (fixedCollapse.eq(index).offset().top <= 210 && fixedCollapse.eq(index).offset().top != 0) {
                                fixedItem.removeAttr('style');
                                fixedItem.eq(index).css({
                                    'position': 'fixed',
                                    'width': fixedItem.eq(index).width(),
                                    'top': '147px',
                                    'z-index': '99'
                                });
                            } else {
                                if (fixedCollapse.eq(index).offset().top > 0) {
                                    fixedItem.eq(index).removeAttr('style');
                                }
                            }
                        });
                    }, 50);
                });
            }
        }
    };
}]);